import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center align-items-center" }

import { ref } from "vue";
import PaymentService from "../services/PaymentService";

import SimpleForm from "@/components/SimpleForm.vue";
import FileUploader from "@/components/FileUploader.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import i18n from "@/core/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadDepositReceiptModal',
  emits: ["fetchData"],
  setup(__props, { expose: __expose, emit: emits }) {



const { t } = i18n.global;
const modelFormRef = ref<InstanceType<typeof SimpleForm>>(null);
const fileUploaderRef = ref<InstanceType<typeof FileUploader>>(null);
const isLoading = ref(false);

const fileGuid = ref<number>();
const fileForm = ref<FormData>();
const id = ref<number>(-1);

const onFileUploaded = (_guid: number, _fileForm: any) => {
  fileGuid.value = _guid;
  fileForm.value = _fileForm;
  // console.log("_guid", _guid);
  // console.log("_fileForm", _fileForm);
};

const show = async (_id: number) => {
  modelFormRef.value?.show();
  id.value = _id;
  fileUploaderRef.value?.clearPreview();
};

const submitUploadReceipt = async () => {
  isLoading.value = true;
  try {
    const res = await PaymentService.postDepositReceiptFile(
      id.value,
      fileForm.value
    );
    if (res) {
      MsgPrompt.success(t("tip.depositUploadSuccess")).then(() => {
        emits("fetchData");
        modelFormRef.value?.hide();
      });
    }
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

__expose({
  show,
  hide: () => modelFormRef.value?.hide(),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modelFormRef",
    ref: modelFormRef,
    title: _ctx.$t('action.uploadReceipt'),
    "is-loading": isLoading.value,
    submit: submitUploadReceipt
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FileUploader, {
          ref_key: "fileUploaderRef",
          ref: fileUploaderRef,
          "file-type": "document",
          title: '',
          onFileUploaded: onFileUploaded,
          hint: "",
          side: "client",
          "disable-default-upload": ""
        }, null, 512)
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})